/* One button for a sold-out pick: Restock Rocket's Notify button says which colour is
   sold out, and the quantity box and grey SOLD OUT button hide (Mo, 2026-10-24). */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var NAME_MAX = 20; // longest name that fits the phone bottom panel at 375 px
  var BELL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>';

  var style = document.createElement('style');
  style.textContent =
    '.vc-oos-one .wt-product__add-to-cart_form--wrapper{display:none!important}' +
    '.restock-rocket-button.vc-oos-btn{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;width:100%;min-height:58px;padding:10px 16px;line-height:1.2;text-transform:uppercase;letter-spacing:.1em}' +
    '.vc-oos-btn .vc-oos-line{font-size:11px;opacity:.75}' +
    '.vc-oos-btn .vc-oos-cta{display:inline-flex;align-items:center;gap:8px;font-size:13px}' +
    '.vc-oos-btn svg{width:14px;height:14px;flex:none}' +
    // The photo badge matches the SOLD OUT tag beside the colour name, on white so it shows on light photos (Rami, 2026-10-26).
    // Both tags have square corners (Sheraz, 2026-10-27); this overrides the round tag in main.css.
    '[data-gallery] .card__badges--item.vc-photo-soldout{background:#fff;color:#6b6b6b;font-size:11px;font-weight:500;line-height:1.6;letter-spacing:.08em;text-transform:uppercase;padding:2px 8px;border-radius:0}' +
    '.wt-product__option:has(.wt-product__option__body--swatches input.disabled:checked) .wt-product__option__title .value::after{border-radius:0}';
  document.head.appendChild(style);

  // Every picked option, so a sized product reads "Mini Black", not just "Black".
  function picked(form) {
    // getAttribute: form.id returns the hidden variant input named "id".
    var id = form.getAttribute('id');
    if (!id) return '';
    return Array.prototype.map.call(document.querySelectorAll('input[type="radio"][form="' + id + '"]:checked'), function (i) {
      return i.value;
    }).join(' ');
  }

  // The photo is fitted whole inside a wider box, so inset the badge from the photo's own corner, not the box's.
  function placeOnPhoto(slot, product) {
    var img = product.querySelector('[data-gallery] .swiper-slide-active img') || product.querySelector('[data-gallery] img');
    if (!img || !img.naturalWidth || !slot.getClientRects().length) return;
    var r = img.getBoundingClientRect();
    var s = slot.getBoundingClientRect();
    var cs = getComputedStyle(slot);
    var w = Math.min(r.width, r.height * img.naturalWidth / img.naturalHeight);
    var h = Math.min(r.height, r.width * img.naturalHeight / img.naturalWidth);
    // Shift from where the slot sits now, so its own margin and offset parent don't matter.
    // Where the header floats over the photo, CSS sets --vc-badge-clear: the least distance from the photo's top edge.
    var clear = parseFloat(cs.getPropertyValue('--vc-badge-clear')) || 0;
    var left = Math.round(parseFloat(cs.left) + r.left + (r.width - w) / 2 + 8 - s.left) + 'px';
    var top = Math.round(parseFloat(cs.top) + r.top + Math.max((r.height - h) / 2 + 8, clear) - s.top) + 'px';
    if (slot.style.left !== left) slot.style.left = left;
    if (slot.style.top !== top) slot.style.top = top;
  }

  var headerOverlap = null;
  function sync(form) {
    var atc = form.querySelector('button[name="add"]');
    var btn = form.querySelector('.restock-rocket-button-container .restock-rocket-button');
    var on = !!(atc && atc.disabled && btn);
    form.classList.toggle('vc-oos-one', on);
    // Sold out badge on the photo's top left, like product cards (Mo, 2026-10-26).
    var product = form.closest('.wt-product');
    var slot = product && product.querySelector('[data-gallery] .card__badges--product');
    if (slot) {
      // On the fashion layout the header floats over the photo: keep the whole slot (theme badges too) below it.
      var hdr = document.querySelector('header.shopify-section-group-header-group') || document.querySelector('header');
      var gal = slot.closest('[data-gallery]');
      if (hdr && gal && slot.closest('[desktop-layout=fashion]')) {
        // How far the header reaches into the photo. The header sticks once the page scrolls, so measure at the top and reuse that.
        if (window.scrollY < 1) headerOverlap = Math.max(0, hdr.getBoundingClientRect().bottom - gal.getBoundingClientRect().top);
        var overlap = headerOverlap === null ? hdr.offsetHeight : headerOverlap;
        var clearPx = Math.ceil(overlap + 8) + 'px';
        if (slot.style.getPropertyValue('--vc-badge-clear') !== clearPx) slot.style.setProperty('--vc-badge-clear', clearPx);
      }
      // The theme disables Add to cart while a colour loads, so also require the sold-out label.
      var label = atc && atc.querySelector('.wt-btn__label span');
      var soldText = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      var soldOut = !!(atc && atc.disabled && label && label.textContent.trim() === soldText);
      var badges = slot.querySelectorAll('.vc-photo-soldout');
      for (var i = 1; i < badges.length; i++) badges[i].remove();
      var badge = badges[0];
      if (soldOut && !badge) {
        badge = document.createElement('div');
        badge.className = 'card__badges--item vc-photo-soldout';
        badge.setAttribute('data-custom-badge', 'sold-out');
        badge.textContent = soldText;
        slot.prepend(badge);
      } else if (!soldOut && badge) {
        badge.remove();
      }
      if (soldOut) placeOnPhoto(slot, product);
    }
    if (!on) return;
    // The app's button lands below the badges on some templates; put it where Add to cart was.
    var row = form.querySelector('.wt-product__add-to-cart_form--wrapper');
    var box = btn.closest('.restock-rocket-button-container');
    if (row && box.previousElementSibling !== row) row.after(box);
    var name = picked(form);
    var line = name && name.length <= NAME_MAX ? name + ' is sold out' : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
    if (btn.dataset.vcOos === line && btn.querySelector('.vc-oos-cta')) return;
    var label = btn.dataset.vcLabel || btn.textContent.trim() || 'Notify me when available';
    btn.dataset.vcLabel = label;
    btn.dataset.vcOos = line;
    btn.classList.add('vc-oos-btn');
    btn.innerHTML = '<span class="vc-oos-line"></span> <span class="vc-oos-cta">' + BELL + '<span></span></span>';
    btn.querySelector('.vc-oos-line').textContent = line;
    btn.querySelector('.vc-oos-cta span').textContent = label;
    // No aria-label: screen readers read the two visible lines, so the name matches what shoppers see.
    btn.removeAttribute('aria-label');
  }

  var queued = false;
  // Look the forms up each time: some product templates add the form after this script runs.
  function syncAll() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(sync);
    }, 30);
  }
  new MutationObserver(syncAll).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  document.addEventListener('change', syncAll);
  // The photo's size settles after it loads and on resize, which moves its corner.
  window.addEventListener('load', syncAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAll);
  window.addEventListener('resize', syncAll);
  document.addEventListener('load', function (e) {
    if (e.target.tagName === 'IMG' && e.target.closest('[data-gallery]')) syncAll();
  }, true);
  syncAll();
})();
